// extracted by mini-css-extract-plugin
export default {"customInput":"styles_customInput__mGyrn","customInputError":"styles_customInputError__ES-Za"};